/**
 * Rive-анимация на FAQ (02_GPT-MODULAR).
 */

import { useRive } from "@rive-app/react-canvas";
import "./RiveAnimation.css";

function RiveAnimation() {
    const { RiveComponent } = useRive({
        src: "/untitled.riv",
        autoplay: true,
    });

    return (
        <div className="faq-image-placeholder">
            <RiveComponent />
        </div>
    );
}

export default RiveAnimation;
// components/RiveAnimation/RiveAnimation.js
